"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STOP_SPEAKING_ACTIVITY = void 0;
exports["default"] = stopSpeakingActivity;
var STOP_SPEAKING_ACTIVITY = 'WEB_CHAT/STOP_SPEAKING';
exports.STOP_SPEAKING_ACTIVITY = STOP_SPEAKING_ACTIVITY;
function stopSpeakingActivity() {
  return {
    type: STOP_SPEAKING_ACTIVITY
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTVE9QX1NQRUFLSU5HX0FDVElWSVRZIiwiZXhwb3J0cyIsInN0b3BTcGVha2luZ0FjdGl2aXR5IiwidHlwZSJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3N0b3BTcGVha2luZ0FjdGl2aXR5LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNUT1BfU1BFQUtJTkdfQUNUSVZJVFkgPSAnV0VCX0NIQVQvU1RPUF9TUEVBS0lORyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHN0b3BTcGVha2luZ0FjdGl2aXR5KCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNUT1BfU1BFQUtJTkdfQUNUSVZJVFlcbiAgfTtcbn1cblxuZXhwb3J0IHsgU1RPUF9TUEVBS0lOR19BQ1RJVklUWSB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsc0JBQXNCLEdBQUcsd0JBQXdCO0FBQUNDLE9BQUEsQ0FBQUQsc0JBQUEsR0FBQUEsc0JBQUE7QUFFekMsU0FBU0Usb0JBQW9CQSxDQUFBLEVBQUc7RUFDN0MsT0FBTztJQUNMQyxJQUFJLEVBQUVIO0VBQ1IsQ0FBQztBQUNIIn0=